<template>
  <g>
    <path fill="#a62626" :style="{fill: $attrs.fgColor}"
          d="m14.38.02c.52-.09,1.08.17,1.33.64.24.42.16.92.15,1.38-.2,4.76-.49,9.52-1.13,14.23-.04.65-.61,1.23-1.27,1.22-.74.05-1.4-.65-1.31-1.39.67-4.91.95-9.87,1.15-14.81,0-.61.48-1.18,1.08-1.27Z"/>
    <path fill="#a62626" :style="{fill: $attrs.fgColor}"
          d="m36.74,7.87c.59-.26,1.29.05,1.61.58,1.04,1.55,1.86,3.42,1.59,5.33-.16,1.34-.98,2.52-2.04,3.31-1.65,1.24-3.62,1.96-5.55,2.62-.46.17-1.01.18-1.42-.13-.5-.36-.67-1.1-.36-1.64.16-.31.47-.52.8-.62,1.62-.54,3.27-1.1,4.7-2.06.6-.41,1.2-.96,1.33-1.71.17-1.07-.3-2.11-.79-3.04-.23-.46-.65-.86-.68-1.4-.04-.54.31-1.06.81-1.25Z"/>
    <path fill="#a62626" :style="{fill: $attrs.fgColor}"
          d="m28.67,9.45c.04-.57.51-1.07,1.08-1.16.66-.11,1.33.39,1.44,1.05.06.41-.03.82-.09,1.23-.35,1.93-1.33,3.78-2.9,4.98-1.33,1.03-3.01,1.53-4.67,1.61-.58.04-1.16,0-1.74,0-1.68,2.54-3.87,4.69-6.22,6.6-.34.29-.73.62-1.21.57-.77,0-1.37-.82-1.17-1.55.13-.59.71-.89,1.13-1.26,1.78-1.48,3.48-3.08,4.81-4.99-.78-.41-1.48-1.05-1.75-1.91-.32-1.02,0-2.13.56-3.01.92-1.42,2.17-2.78,3.85-3.25.8-.24,1.72.27,1.94,1.08.46,1.72.03,3.52-.57,5.15,1.4,0,2.85-.42,3.88-1.42,1.03-.96,1.53-2.36,1.65-3.73Zm-8.54,3.39c-.19.33-.41.68-.38,1.07.17.21.44.31.68.42.47-.87.76-1.84.86-2.82-.49.34-.84.84-1.16,1.33Z"/>
    <path fill="#a62626" :style="{fill: $attrs.fgColor}"
          d="m8.71,8.97c.81-.34,1.77.37,1.73,1.23-.06,1.28-.37,2.54-.76,3.76-1.35,4.1-4.15,7.63-7.64,10.14-.61.43-1.56.23-1.89-.45-.31-.57-.09-1.3.45-1.65,2.65-1.94,4.89-4.52,6.19-7.56.59-1.38,1.02-2.84,1.13-4.33.02-.5.35-.95.81-1.13Z"/>
    <path fill="#a62626" :style="{fill: $attrs.fgColor}"
          d="m27.47,18.42c.38-.09.81-.13,1.16.1.6.33.82,1.18.46,1.76-.19.33-.53.54-.89.62-1.69.39-3.4.65-5.13.75-.51.05-1.04-.21-1.28-.67-.29-.51-.18-1.23.29-1.6.27-.25.64-.31.99-.33,1.48-.11,2.95-.32,4.41-.63Z"/>
  </g>
</template>

<script>
export default {
  name: "svgDivar"
}
</script>

<style scoped>

</style>